var _circle, _path, _path2, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _line, _rect, _path12, _path13, _mask, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqIcon15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 71,
    viewBox: "0 0 106 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 17,
    r: 14.5,
    fill: "white",
    stroke: "#D0D5DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 10V24",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 17H98",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 55,
    r: 14.5,
    fill: "white",
    stroke: "#D0D5DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84 55H98",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5039 67L23.8039 54.724V55.3H16.5319V54.31H24.7759V55.138L18.7279 67H17.5039ZM31.4469 67.144C30.0309 67.144 28.9449 66.592 28.1889 65.488C27.4329 64.372 27.0549 62.764 27.0549 60.664C27.0549 58.528 27.4329 56.914 28.1889 55.822C28.9449 54.718 30.0309 54.166 31.4469 54.166C32.8749 54.166 33.9609 54.718 34.7049 55.822C35.4609 56.914 35.8389 58.522 35.8389 60.646C35.8389 62.758 35.4609 64.372 34.7049 65.488C33.9489 66.592 32.8629 67.144 31.4469 67.144ZM31.4469 66.154C32.5389 66.154 33.3549 65.704 33.8949 64.804C34.4349 63.904 34.7049 62.518 34.7049 60.646C34.7049 58.75 34.4349 57.364 33.8949 56.488C33.3549 55.6 32.5389 55.156 31.4469 55.156C30.3669 55.156 29.5509 55.606 28.9989 56.506C28.4589 57.394 28.1889 58.768 28.1889 60.628C28.1889 62.512 28.4589 63.904 28.9989 64.804C29.5509 65.704 30.3669 66.154 31.4469 66.154ZM45.1993 59.692C44.6593 59.692 44.1733 59.572 43.7413 59.332C43.3213 59.08 42.9853 58.744 42.7333 58.324C42.4933 57.904 42.3733 57.43 42.3733 56.902C42.3733 56.374 42.4933 55.906 42.7333 55.498C42.9853 55.078 43.3213 54.748 43.7413 54.508C44.1733 54.256 44.6593 54.13 45.1993 54.13C45.7393 54.13 46.2193 54.25 46.6393 54.49C47.0593 54.73 47.3893 55.06 47.6293 55.48C47.8813 55.9 48.0073 56.374 48.0073 56.902C48.0073 57.43 47.8813 57.91 47.6293 58.342C47.3893 58.762 47.0593 59.092 46.6393 59.332C46.2193 59.572 45.7393 59.692 45.1993 59.692ZM45.1993 58.414C45.6193 58.414 45.9613 58.27 46.2253 57.982C46.4893 57.694 46.6213 57.334 46.6213 56.902C46.6213 56.482 46.4893 56.128 46.2253 55.84C45.9613 55.552 45.6193 55.408 45.1993 55.408C44.7793 55.408 44.4313 55.552 44.1553 55.84C43.8913 56.128 43.7593 56.482 43.7593 56.902C43.7593 57.334 43.8913 57.694 44.1553 57.982C44.4313 58.27 44.7793 58.414 45.1993 58.414ZM55.7318 67.18C54.4118 67.18 53.2778 66.916 52.3298 66.388C51.3938 65.848 50.6738 65.092 50.1698 64.12C49.6658 63.136 49.4138 61.978 49.4138 60.646C49.4138 59.314 49.6658 58.162 50.1698 57.19C50.6738 56.218 51.3938 55.468 52.3298 54.94C53.2778 54.4 54.4118 54.13 55.7318 54.13C56.6198 54.13 57.4178 54.256 58.1258 54.508C58.8458 54.76 59.4638 55.132 59.9798 55.624L59.2238 57.46C58.6598 57.004 58.1138 56.68 57.5858 56.488C57.0698 56.284 56.4758 56.182 55.8038 56.182C54.5198 56.182 53.5358 56.572 52.8518 57.352C52.1798 58.12 51.8438 59.218 51.8438 60.646C51.8438 62.074 52.1798 63.178 52.8518 63.958C53.5358 64.738 54.5198 65.128 55.8038 65.128C56.4758 65.128 57.0698 65.032 57.5858 64.84C58.1138 64.636 58.6598 64.3 59.2238 63.832L59.9798 65.668C59.4638 66.148 58.8458 66.52 58.1258 66.784C57.4178 67.048 56.6198 67.18 55.7318 67.18Z",
    fill: "#7C7C7C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22222 62.5081V52.2726C7.22222 51.6698 6.9881 51.0918 6.57135 50.6656C6.1546 50.2394 5.58937 50 5 50C4.41063 50 3.8454 50.2394 3.42865 50.6656C3.0119 51.0918 2.77778 51.6698 2.77778 52.2726V62.5081C2.06425 62.9957 1.52295 63.705 1.23384 64.5313C0.94473 65.3575 0.923129 66.257 1.17223 67.0968C1.42133 67.9366 1.92792 68.6722 2.61719 69.195C3.30646 69.7178 4.14185 70 5 70C5.85815 70 6.69354 69.7178 7.38281 69.195C8.07208 68.6722 8.57867 67.9366 8.82777 67.0968C9.07687 66.257 9.05527 65.3575 8.76616 64.5313C8.47705 63.705 7.93575 62.9957 7.22222 62.5081Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.135 1C32.4695 1.51709 32.9176 2.92358 32.436 3.79229C31.8341 4.87818 31.4328 5.42113 31.3325 6.19677C31.2322 6.9724 31.2322 8.21342 32.0347 9.06662",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3616 1C27.696 1.51709 28.1442 2.92358 27.6626 3.79229C27.0607 4.87818 26.6594 5.42113 26.559 6.19677C26.4587 6.9724 26.4587 8.21342 27.2613 9.06662",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4861 1C22.8205 1.51709 23.2687 2.92358 22.7871 3.79229C22.1852 4.87818 21.7839 5.42113 21.6836 6.19677C21.5832 6.9724 21.5832 8.21342 22.3858 9.06662",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4775 30.5754L8.8678 12.75H41.2308L38.6212 30.5754C37.635 37.3116 31.8573 42.305 25.0493 42.305C18.2414 42.305 12.4636 37.3116 11.4775 30.5754Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7998 13.2676L25.7998 39.5",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3169 13.2334L18.5005 40.5",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 29.3182,
    y2: -0.75,
    transform: "matrix(-0.0567021 0.998391 -0.999033 -0.0439766 33.5747 12.5176)",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 17.9258,
    width: 32.5986,
    height: 6.78134,
    rx: 1.25,
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1272 14.5708C51.6106 12.4174 51.2646 10.506 49.6985 10.1544C48.1324 9.80285 46.6481 11.3033 46.1647 13.4567",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5331 33.9568L46.2065 13.1396",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-1_384_4370",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 32.9454C22 35.5831 23.0478 38.1128 24.9129 39.9779C26.7781 41.843 29.3077 42.8909 31.9454 42.8909C34.5831 42.8909 37.1128 41.843 38.9779 39.9779C40.843 38.1128 41.8909 35.5831 41.8909 32.9454L31.9454 32.9454L22 32.9454Z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22 32.9454C22 35.5831 23.0478 38.1128 24.9129 39.9779C26.7781 41.843 29.3077 42.8909 31.9454 42.8909C34.5831 42.8909 37.1128 41.843 38.9779 39.9779C40.843 38.1128 41.8909 35.5831 41.8909 32.9454L31.9454 32.9454L22 32.9454Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 3,
    mask: "url(#path-18-inside-1_384_4370)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon15);
export default __webpack_public_path__ + "static/media/faq-icon15.68c6dc560195e77092ade8395b8e837b.svg";
export { ForwardRef as ReactComponent };